import { render, staticRenderFns } from "./ConfigurationTemperature.vue?vue&type=template&id=36c0887a&scoped=true&"
import script from "./ConfigurationTemperature.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationTemperature.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationTemperature.vue?vue&type=style&index=0&id=36c0887a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c0887a",
  null
  
)

export default component.exports